export default __webpack_public_path__ + "static/media/breadcrumb-separation.3159bba4.svg";